import Vue from 'vue';
import http from "@/http";
import axios from "axios";
import * as types from "./types";

const actions = {
    [types.UPDATE_RECIPE_COMPONENT]({ dispatch, commit, state, rootGetters },
      {
        componentName,
        swatchId,
        group,
        subgroup,
        factorySwatchGroup,
        factorySwatchSubgroup,
        material_type,
        ugc,
        updatePrice,
        sub_components,
      }) {
        if (componentName.search('/') !== -1){
          const component = componentName.split('/');
          if (state.recipe_v2.components?.[component[0]]?.sub_components?.[component[1]]) {
            commit(types.UPDATE_COMPONENT, {
              componentName,
              data: {
                ...state.recipe_v2.components[component[0]].sub_components[component[1]],
                swatch_id: parseInt(swatchId),
                group: factorySwatchGroup || group,
                subgroup: factorySwatchSubgroup || subgroup,
                material_type,
              },
            });

            // checks if the component is the right sleeve and repeats the operation for the left sleeve
            if (component[0] === "graphic_sleeve_right") {
              commit(types.UPDATE_COMPONENT, {
                componentName: `graphic_sleeve_left/${component[1]}`,
                data: {
                  ...state.recipe_v2.components[component[0]].sub_components[component[1]],
                  swatch_id: parseInt(swatchId),
                  group: factorySwatchGroup || group,
                  subgroup: factorySwatchSubgroup || subgroup,
                  material_type,
                },
              });
            }

            if (ugc) {
              commit(types.UPDATE_COMPONENT, {
                componentName,
                data: {
                  ...state.recipe_v2.components[component[0]].sub_components[component[1]],
                  ugc,
                },
              });

              // checks if the component is the right sleeve and repeats the operation for the left sleeve
              if (component[0] === "graphic_sleeve_right") {
                commit(types.UPDATE_COMPONENT, {
                  componentName: `graphic_sleeve_left/${component[1]}`,
                  data: {
                    ...state.recipe_v2.components[component[0]].sub_components[component[1]],
                    ugc,
                  },
                });
              }
            }
            if(updatePrice) {
              dispatch('buyPanel/GET_PRICE', { recipe: state.recipe_v2 }, { root: true });
            }
          }
        } else {
          if (state.recipe_v2.components?.[componentName]) {
            // get graphic transform data and apply to toolkit_options
            let toolkit_options
            if ( group === 'graphics' ) {
              const transform = rootGetters["gdm/getGraphicsTransform"](componentName) ?? null
              if (transform) {
                toolkit_options = {transform: {...transform}}
              }
            }
            commit(types.UPDATE_COMPONENT, {
              componentName,
              data: {
                ...state.recipe_v2.components[componentName],
                swatch_id: parseInt(swatchId),
                group: factorySwatchGroup || group,
                subgroup: factorySwatchSubgroup || subgroup,
                material_type,
                sub_components,
                toolkit_options
              },
            });
            // checks if the component is the right sleeve and repeats the operation for the left sleeve
            if (componentName === "graphic_sleeve_right") {
              // get graphic transform data and apply to toolkit_options
              let toolkit_options
              if ( group === 'graphics' ) {
                const transform = rootGetters["gdm/getGraphicsTransform"]('graphic_sleeve_left')
                if (transform) {
                  toolkit_options = {transform: {...transform}}
                }
              }
              commit(types.UPDATE_COMPONENT, {
                componentName: "graphic_sleeve_left",
                data: {
                  ...state.recipe_v2.components["graphic_sleeve_left"],
                  swatch_id: parseInt(swatchId),
                  group: factorySwatchGroup || group,
                  subgroup: factorySwatchSubgroup || subgroup,
                  material_type,
                  sub_components,
                  toolkit_options
                },
              });
            }

            if (ugc) {
              commit(types.UPDATE_COMPONENT, {
                componentName,
                data: {
                  ...state.recipe_v2.components[componentName],
                  ugc,
                },
              });
              // checks if the component is the right sleeve and repeats the operation for the left sleeve
              if (componentName === "graphic_sleeve_right") {
                commit(types.UPDATE_COMPONENT, {
                  componentName: "graphic_sleeve_left",
                  data: {
                    ...state.recipe_v2.components["graphic_sleeve_left"],
                    ugc,
                  },
                });
              }
            }
            if(updatePrice || group === 'graphics') {
              dispatch('buyPanel/GET_PRICE', { recipe: state.recipe_v2 }, { root: true });
            }
          }
        }
    },
    [types.GET_RECIPE](context, { recipe_id, type = 'customizer', setData = false }) {
      let requestUrl = `${this.state.endPoints[type].recipe}/${recipe_id}`;

      if (this.state.utils.queryParams.slim){
        requestUrl = `${requestUrl}?ignoreStatus=true&checkIsSwatchesEnabled=false`
      }

      const recipePromise = new Promise((resolve, reject) => {
        http.get(requestUrl)
          .then(({ data }) => {

            const isPersonaliationInvalid = context.rootState.transferDesign.isPersonalizationInvalid;
            const isDesignTransfering = context.rootState.utils.isDesignTransfering;
            if (isPersonaliationInvalid && isDesignTransfering) {
              const personalizationComponent = context.rootGetters['personalization/getPersonalizationComponentName'];
              delete data['components'][personalizationComponent]['personalization'];
            }
            resolve(data);
          })
          .catch(reject);
      });
      return recipePromise.then((data) => {
        if (setData) {
          context.commit(types.SET_RECIPE_V2, data);
          context.commit(types.SET_RECIPE_ID, data.recipe_id);
        }
        return data;
      });
    },
    async [types.SAVE_RECIPE](context, { recipe, requestParams, type = 'customizer', enabledBuildUGC = false, skipImageModeration = true }) {
        if (!recipe) throw new Error("The recipe param is required");
        recipe = JSON.parse(JSON.stringify(recipe));

        const isApparelEnabled = context.rootGetters['utils/isApparelEnabled']

        // validates UGC components
        if (context.rootState.utils.configuration.enableRecipeValidation) {
          const invalidUGCComponents = Vue.prototype.$recipe.getInvalidUGCComponents(recipe);
          if (invalidUGCComponents.length > 0) {
            context.commit(types.SET_INVALID_UGC_COMPONENTS, invalidUGCComponents);
            return Promise.reject('InvalidRecipeError');
          }
        }

        if (isApparelEnabled || enabledBuildUGC) {
          const requestUgcUrl = `${this.state.endPoints[type].buildRecipeUgc}`;
          recipe = await new Promise((resolve, reject) => {
            axios({
                url: requestUgcUrl,
                method: "POST",
                headers: { "content-type": "application/json" },
                data: JSON.stringify(recipe)
            })
            .then(({ data }) => {
                resolve(data);
            })
            .catch(reject);
        });
        }

        const requestUrl = `${ context.rootState.endPoints[type].recipe }?skipImageModeration=${skipImageModeration}`;

        delete recipe.recipe_id;
        return new Promise((resolve, reject) => {
            axios({
                url: requestUrl,
                method: "POST",
                headers: { "content-type": "application/json" },
                data: JSON.stringify(recipe)
            })
            .then(({ data }) => {
                context.commit(types.SET_RECIPE_V2, recipe);
                context.commit(types.SET_RECIPE_ID, data.recipeId);
                resolve(data);
            })
            .catch(reject);
        });
    },
    [types.CHECK_MODERATION](context) {
      const recipeId = context.rootState.recipe.recipe_v2.recipe_id;
      const requestUrl = `${context.rootState.endPoints.customizer.filterImages}/${recipeId}`;

      return http
      .get(requestUrl)
      .then(({ data }) => {
        return data;
      });
    }
};

export default actions;
